import { Component, OnInit } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [SvgIconComponent]
})
export class LoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
